import { render, staticRenderFns } from "./multiselect.vue?vue&type=template&id=d60ec394&scoped=true"
import script from "./multiselect.vue?vue&type=script&lang=js"
export * from "./multiselect.vue?vue&type=script&lang=js"
import style0 from "./multiselect.vue?vue&type=style&index=0&id=d60ec394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60ec394",
  null
  
)

export default component.exports